import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom"

const TimedOut = () => {
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const [orderDetails, setOrderDetails] = useState()


    useEffect(() => {
        let upiObj = {};
        if (searchParams.size) {
            for (const entry of searchParams.entries()) {
                upiObj[entry[0]] = entry[1]
            }
           setOrderDetails((prev)=>({...prev,...upiObj}))
        }
        // fetch(`${process.env.REACT_APP_API_BASE_URL}/pay/transaction/merchant-urls-info?orderId=${upiObj.orderId}`, { method: "POST" }).then(res => res.json()).then((res) => {
        fetch(`${window.location.origin}/pay/transaction/merchant-urls-info?orderId=${upiObj.orderId}`, { method: "POST" }).then(res => res.json()).then((res) => {
            if (res?.data == "Failed") {
                // window.open(location.state,"_self")
            } else {
                let obj = Object.entries(res?.data || {}).reduce((acc, [key, value]) => {
                    if (value) acc[key] = value; 
                    return acc;
                  }, {}) 
                  
                setOrderDetails((prev)=>({...prev, ...obj}))
            }
        })
    }, [searchParams])
    return <div className="main-box">
                <div className="cancelled-box">
                    <h4 className="title">Transaction Timed Out</h4>
                    <p>We were unable to complete your transaction in the allocated time. Please try again.</p>
                    <button className="back-button" onClick={()=>{window.open(orderDetails?.failedRedirectionURL,"_self")}}>Back to home</button>
                </div>
            </div>
}

export default TimedOut